import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { ApiQueryAutocomplete } from "../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { DebtorsSupportAdminResponse, SupportInvoicingQuery, fetchDebtors } from "../adminInvoicingApi"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { Debtor } from "../adminInvoicingTypes"

const useStyles = makeStyles()((_theme) => ({
    input: {
        width: "20rem",
        backgroundColor: "white",
    },
}))

const selectDebtors = (data: DebtorsSupportAdminResponse) => data?.debtors || []

type DebtorSelectorProps = Readonly<{
    debtorId: Debtor | null
    handleChange: (el: Debtor | null) => void
}>

export const DebtorSelector = memo(({ debtorId, handleChange }: DebtorSelectorProps) => {
    const { classes } = useStyles()

    const {
        data: debtorsResult = [],
        isLoading,
        isError,
    } = useApiQuery(fetchDebtors, {
        queryName: SupportInvoicingQuery.DEBTORS_LIST,
        dependencies: {},
        select: selectDebtors,
    })

    return (
        <>
            <LocalizedStrict id="support-reports-invoicing-table-debtor-label" attrs={{ label: true }}>
                <ApiQueryAutocomplete
                    isLoading={isLoading}
                    isError={isError}
                    options={debtorsResult}
                    value={debtorId}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, value) => handleChange(value)}
                    label="Debtor"
                    slotProps={{
                        textField: { className: classes.input },
                        errorSelect: { className: classes.input },
                    }}
                />
            </LocalizedStrict>
        </>
    )
})
